import { useState, useRef } from "react";
import { Observer } from "mobx-react";

import { FileSelectButton, CheckBox, Button } from "components/UI";

import style from "./style";
import translationStore from "stores/translation-store";

export default function UploadTitle(props)
{
  const subtitleRef = useRef();
  const fileInputRef = useRef();

  const [title, setTitle] = useState('');
  const [subTitle, setSubTitle] = useState('');
  const [oldEditorEnabled, setOldEditorEnabled] = useState(props.oldEditorEnabled);
  const titlesFilled = title.length > 0 || subTitle.length > 0;

  function onSelectFiles(files)
  {
    props.onComplete({title, subTitle, files, oldEditorEnabled});
  }

  function isEnter(e)
  {
    return (e.key.toLowerCase() === "enter");
  }

  function focusSubtitle(e)
  {
    if(isEnter(e))
    {
      subtitleRef.current.focus();
    }
  }

  function selectFiles(e)
  {
    if(isEnter(e) && titlesFilled)
    {
      if(fileInputRef.current)
        fileInputRef.current.click();
      else
        onSelectFiles();
    }
  }

  return (
    <Observer>
    {
      () =>
      <>
        <div className="title">{translationStore.translate("myalbums.add.title")}</div>
        <div className="subtitle">{translationStore.translate("myalbums.add.title.description")}</div>
        <div className="titles">
          <input onKeyDown={e => focusSubtitle(e)} autoFocus type="text" name="title" placeholder={translationStore.translate("rte.title1")} value={title} onChange={e => setTitle(e.target.value)} />
          <input onKeyDown={e => selectFiles(e)} ref={subtitleRef} type="text" name="subtitle" placeholder={translationStore.translate("rte.title2")} value={subTitle} onChange={e => setSubTitle(e.target.value)} />
        </div>

        <div style={{height: 10}} />

        <CheckBox
          selected={oldEditorEnabled}
          onChange={checked => {
            setOldEditorEnabled(checked);
          }}
          style={{
            fontSize: 20,
            fontWeight: 200,
            alignItems: "flex-start"
          }}
        >
          <div
            style={{
              fontFamily: "Roboto Slab",
              fontSize: '1.4rem',
            }}
          >{translationStore.translate("myalbums.add.use-old-editor")}</div>
        </CheckBox>

        <div className='spacer'></div>

        {oldEditorEnabled && (
          <FileSelectButton
            ref={fileInputRef}
            enabled={titlesFilled}
            className="accent large"
            onSelect={onSelectFiles}
            multiple
          >
            {translationStore.translate("myalbums.add.button")}
          </FileSelectButton>
        )}

        {!oldEditorEnabled && (
          <Button className="accent large" enabled={titlesFilled} onClick={onSelectFiles}>{translationStore.translate("myalbums.add.choose-template-button")}</Button>
        )}

        <style jsx>{style}</style>
        <style jsx>
        {`
          .titles {
            display: flex;
            flex-direction: column;
            margin-top: 5rem;
            width: 100%;
          }

          .titles input+input {
            margin-top: 10px;
          }

          .spacer {
            margin-bottom: 5rem;
          }
        `}
        </style>
      </>
    }
    </Observer>
  );
}